import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { selectIsEventRunningByEventType } from "../../selectors/selectEventInfo";
import { selectPlayerInfo } from "../../selectors/selectPlayerInfo";
import { selectIsTournamentLevelMatched } from "../../selectors/selectTournamentInfo";
import { EventType } from "../balancing/types/BalancingCore";
import { IdTeasers } from "./IdTeasers";
import { LeagueInfo } from "./LeagueInfo";
import { TabTournamentTeaser } from "./TabTournamentTeaser";
var _TabCoopLeague = function (_a) {
    var isCoopLeagueRunning = _a.isCoopLeagueRunning, canPlayerParticipate = _a.canPlayerParticipate, playerHasCoop = _a.playerHasCoop;
    if (!playerHasCoop) {
        return React.createElement(TabTournamentTeaser, { type: IdTeasers.PlayerHasNoCoop });
    }
    else if (!canPlayerParticipate) {
        return React.createElement(TabTournamentTeaser, { type: IdTeasers.PlayerLevelTooLowCoop });
    }
    else if (!isCoopLeagueRunning) {
        return React.createElement(TabTournamentTeaser, { type: IdTeasers.NoCoopLeagueRunning });
    }
    else {
        return React.createElement(LeagueInfo, null);
    }
};
var mapState = function (state) {
    var playerCoopId = selectPlayerInfo(state).coopId;
    return {
        canPlayerParticipate: selectIsTournamentLevelMatched(state, EventType.CoopLeague),
        isCoopLeagueRunning: selectIsEventRunningByEventType(state, EventType.CoopLeague),
        playerHasCoop: playerCoopId !== undefined && playerCoopId.notEquals(Long.ZERO),
    };
};
export var TabCoopLeague = connect(mapState)(_TabCoopLeague);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/TabCoopLeague.tsx
// module id = 2778
// module chunks = 3